class GetSignedUrlDto {
  name!: string;
  contentType!: string;
}

export default GetSignedUrlDto;
